module.exports = __webpack_public_path__ + "img/help_permissions.f5fadc5e.jpg";